﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.roomBlockHeadersFilter
 * @description
 * # roomBlockHeadersFilter
 */

/*jshint sub:true*/
angular.module('ntmApp')
  .filter('roomBlockHeadersFilter', function () {

      return function (items, selectedRoom, forecastFilter, showOnlyPinned) {

          if (items) {
              var filteredByRoomNumber = selectedRoom && selectedRoom.id ? items.filter(function (item) {
                  return item.roomNumber === selectedRoom.id;
              }) : items;

              var filtered = filteredByRoomNumber.filter(function (item) {
                  var isAppliedByFilters = forecastFilter.isBlockHeaderApplied(item);

                  if (showOnlyPinned) {
                      return isAppliedByFilters && item.pinned;
                  }

                  return isAppliedByFilters;
              });

              var pinnedItems = items.filter(function (item) {
                  return item.pinned;
              });

              return filtered.uniqueUnion(pinnedItems);
          }

          return items;
      };
  });